import React from 'react';

/**
 * SelectElement - Independent dropdown select component
 * Fully self-contained with no external layout dependencies
 */
const SelectElement = ({ element, mode = 'form' }) => {
  const { content } = element;
  const {
    label = 'Dropdown',
    name = '',
    options = ['Option 1', 'Option 2', 'Option 3'],
    required = false,
    placeholder = 'Choose an option...',
    helpText = ''
  } = content || {};

  // Generate field name from label if not provided
  const fieldName = name || label.toLowerCase().replace(/[^a-z0-9]+/g, '_');

  return (
    <div className="form-field" style={{ width: '100%', boxSizing: 'border-box' }}>
      {label && (
        <label className="form-label" htmlFor={fieldName}>
          {label}
          {required && <span className="form-required"> *</span>}
        </label>
      )}
      <select
        id={fieldName}
        name={fieldName}
        className="form-select"
        required={required}
        aria-required={required}
        aria-describedby={helpText ? `${fieldName}-help` : undefined}
        defaultValue=""
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
      {helpText && (
        <p
          id={`${fieldName}-help`}
          className="form-help-text"
          style={{ fontSize: '0.875rem', color: 'var(--color-text-secondary)', marginTop: '0.25rem' }}
        >
          {helpText}
        </p>
      )}
    </div>
  );
};

export default SelectElement;
